import { useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import { Button, message, Upload } from 'antd'
import { RcFile, UploadChangeParam } from 'antd/lib/upload'
import { v4 as uuidv4 } from 'uuid'
import { UploadFile } from 'antd/lib/upload/interface'
import { UploadOutlined } from '@ant-design/icons'
import { useAuth } from '../../lib/hooks'

const SIGNED_URL_QUERY = gql`
  mutation SignedUrl($filename: String!) {
    signed: signedUrlAction(filename: $filename) {
      url
    }
  }
`
const D4UploadFile = ({ onOk }: { onOk: ({ auteur_id, nomfichier, nomstockage }: UploadFileResult) => void }) => {
  const [getSignedUrl] = useMutation<{ signed: { url: string } }, { filename: string }>(SIGNED_URL_QUERY)
  const [loadingDoc, setLoadingDoc] = useState(false)
  const { user } = useAuth()

  const beforeUpload = (file: RcFile) => {
    const isLt2M = file.size / 1024 / 1024 < 10
    if (!isLt2M) {
      message.error('Image must smaller than 10MB!')
    }
    return true
  }

  const handleUpload = async ({
    onSuccess,
    onError,
    file,
  }: {
    onSuccess: Function
    onError: Function
    file: RcFile
  }) => {
    const filename = uuidv4() + '_' + file.name
    /**
     * Recupère une url signée par aws s3 pour avoir la permission d'upload sur le bucket
     */
    const apiUrl = await getSignedUrl({
      variables: {
        filename,
      },
    })

    if (!apiUrl.data?.signed.url) {
      onError()
    }

    /**
     * PUT le fichier sur AWS S3
     */
    const res = await window.fetch(apiUrl.data?.signed.url ?? '', {
      method: 'PUT',
      body: file,
    })

    if (res.statusText === 'OK') {
      await onOk({ nomfichier: file.name, nomstockage: filename, auteur_id: Number(user.personne.id) })
      onSuccess(null, file)
    } else {
      onError()
    }
  }

  const onChange = (info: UploadChangeParam<UploadFile<any>>) => {
    if (info.file.status === 'uploading') {
      setLoadingDoc(true)
    }
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      setLoadingDoc(false)
      message.success(`${info.file.name} a bien été téléchargé`)
    } else if (info.file.status === 'error') {
      setLoadingDoc(false)
      message.error(`Le téléchargement de ${info.file.name} a échoué.`)
    }
  }

  return (
    <Upload
      name="file"
      onChange={onChange}
      beforeUpload={beforeUpload}
      //@ts-expect-error
      customRequest={handleUpload}
      showUploadList={false}
    >
      <Button icon={<UploadOutlined />} loading={loadingDoc} disabled={loadingDoc}>
        Télécharger un fichier
      </Button>
    </Upload>
  )
}

export default D4UploadFile
